/* unplugin-vue-components disabled */import script from "./pie.vue?vue&type=script&setup=true&lang=js"
export * from "./pie.vue?vue&type=script&setup=true&lang=js"

import "./pie.vue?vue&type=style&index=0&id=adf908a2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-adf908a2"]])

export default __exports__